<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-4">
      <div>
        <div class="text-subtitle-2 font-weight-bold">{{ $t('documents.kycTab') }}</div>
        <div class="caption grey--text">{{ isPro ? $t('documents.kycSummaryPro') : $t('documents.kycSummary') }}</div>
      </div>

      <div class="d-flex align-center">
        <v-chip v-if="documents.length" small color="aliveTransp" text-color="alive" class="font-weight-bold mr-3">
          {{ documents.length }} {{ $t(documents.length === 1 ? 'documents.document' : 'documents.documents').toLowerCase() }}
        </v-chip>
        <v-btn
          v-if="documents.length"
          small
          outlined
          color="primary"
          class="zip-btn text-none"
          :loading="zipping"
          :disabled="zipping"
          data-testid="documents-download-archive"
          @click="$emit('download-zip')"
        >
          <v-icon small left>mdi-folder-zip</v-icon>
          {{ $t('documents.downloadAll') }}
        </v-btn>
      </div>
    </div>

    <v-card v-if="documents.length" class="documents-tab-card" outlined>
      <v-simple-table dense class="documents-tab-table">
        <thead>
          <tr>
            <th>{{ $t('documents.filename') }}</th>
            <th style="width: 165px;">{{ $t('documents.uploaded') }}</th>
            <th style="width: 80px;">{{ $t('documents.size') }}</th>
            <th class="text-right" style="width: 44px;"></th>
          </tr>
        </thead>
        <tbody>
          <documents-slot-row
            v-for="(document, index) in documents"
            :key="`${document.sha256}-${index}`"
            :document="document"
            :downloading="downloadingSha === document.sha256"
            @download="$emit('download', document)"
          />
        </tbody>
      </v-simple-table>
    </v-card>

    <!-- Empty state -->
    <v-card v-else class="empty-state-card text-center py-12" outlined>
      <v-icon size="48" color="grey darken-2">mdi-file-account-outline</v-icon>
      <div class="grey--text text--lighten-1 mt-3 font-weight-medium">
        {{ $t('documents.noDocuments') }}
      </div>
      <div class="caption grey--text text--darken-1 mt-1">
        {{ isPro ? $t('documents.noKycDocumentsPro') : $t('documents.noKycDocuments') }}
      </div>
    </v-card>
  </div>
</template>

<script>
import DocumentsSlotRow from './DocumentsSlotRow.vue'

export default {
  name: 'DocumentsKycTab',

  components: { DocumentsSlotRow },

  props: {
    isPro:          { type: Boolean, default: false },
    documents:      { type: Array, default: () => [] },
    downloadingSha: { type: String, default: null },
    zipping:        { type: Boolean, default: false },
  },

  emits: ['download', 'download-zip'],
}
</script>

<style scoped lang="scss">
.documents-tab-card {
  background: #181818 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 10px !important;
  overflow: hidden;
}

.zip-btn {
  font-size: 11px !important;
  letter-spacing: 0.01em;
}

.documents-tab-table {
  background: transparent !important;

  ::v-deep table {
    table-layout: fixed !important;
    width: 100% !important;
  }

  ::v-deep .v-data-table__wrapper {
    overflow-x: hidden !important;
  }

  ::v-deep thead th,
  ::v-deep tbody td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  ::v-deep thead th:first-child,
  ::v-deep tbody td:first-child {
    padding-left: 14px !important;
  }

  ::v-deep thead th:last-child,
  ::v-deep tbody td:last-child {
    padding-right: 14px !important;
  }

  ::v-deep thead th {
    font-size: 0.75rem !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: rgba(255, 255, 255, 0.5) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
    white-space: nowrap !important;
  }
}

.empty-state-card {
  background: rgba(255, 255, 255, 0.02) !important;
  border: 1px dashed rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
}
</style>
